import { useMemo, memo, Dispatch, SetStateAction } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { RouteParams } from '../types';
import styles from './Products.module.scss';
import { SearchStateProps } from '@/redux/store/reducer/searchReducer';
import FilterSorting from '../reusable/filterSorting/FilterSorting';
import Cards from './cards/Cards';
import MapSection from './mapSection/MapSection';
import Pagination from './pagination/Pagination';
import SearchFooter from './searchFooter/SearchFooter';
import CardsSkeleton from './cards/cardsSkeleton/CardsSkeleton';
import MidTermBannerFeatures from './midTermBannerFeatures/MidTermBannerFeatures';
import { SearchDataProps } from '../_types/searchDataType';
import Box from '@/components/UI/box/Box';
import { ProductListRecord } from '@/components/reusable/productCard/types';
import BundleBanner from './bundleBanner/BundleBanner';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';

// const FilterTehranTabs = dynamic(
//   () => import('../reusable/filterTehranTabs/FilterTehranTabs'),
//   {
//     ssr: false,
//   },
// )

const EmptyList = dynamic(() => import('./emptyList/EmptyList'), {
  ssr: false
});
interface ProductsProps {
  perPage: number;
  params: RouteParams;
  isShowMap: boolean;
  mapFullscreen: boolean;
  setMapFullscreen: Dispatch<SetStateAction<boolean>>;
  data: SearchDataProps;
  loading: boolean;
  firstData: SearchStateProps;
  isBot: boolean;
}
const Products = ({
  perPage,
  params,
  isShowMap,
  mapFullscreen,
  setMapFullscreen,
  data,
  loading,
  firstData,
  isBot
}: ProductsProps) => {
  const router = useRouter();
  const isTehran = useMemo(() => params.city === 'تهران', [params.city]);
  const isWhiteLabel = useIsWhiteLabel();
  return <>
      {/* {isTehran && !isMobile && !router.query?.near_cities && ( */}
      {/* <FilterTehranTabs /> */}
      {/* )} */}
      {data && data.list?.length === 0 || firstData.list?.length === 0 ? <>
          <FilterSorting data={data} />
          <EmptyList />
        </> : <Box className={styles['products-main-container']} component={'main'}>
          <Box className={styles['products-container'] + ' ' + `${isShowMap ? styles['show-map'] : ''}` + ' ' + `${mapFullscreen ? styles['map-full-screen'] : ''}`}>
            {(loading || !data?.list) && !isBot ? <>
                <FilterSorting data={data as SearchDataProps} />
                <CardsSkeleton isShowMap={isShowMap} firstData={firstData} />
              </> : <>
                {/* {isTehran && !isMobile && !router.query?.near_cities && (
                 <FilterTehranTabs />
                 )} */}
                {data?.discount_motivation?.total_discount_amount && !router.query.mid_term && !isWhiteLabel && <BundleBanner data={data.discount_motivation} />}
                {params.city === 'تهران' && !!data.list && router.query.mid_term && <MidTermBannerFeatures />}
                <FilterSorting data={data} />
                <Cards isShowMap={isShowMap} page={Number(router.query?.page) || 1} perPage={perPage} data={data?.list} searchId={data?.search_id} />
                <Pagination perPage={perPage} data={data} />
              </>}
            {data?.region_data && !isWhiteLabel && <SearchFooter url={params.url as string} region_data={data?.region_data} />}
          </Box>
          <Box className={styles['map-container'] + ' ' + `${isShowMap ? styles['show-map'] : ''}` + ' ' + `${mapFullscreen ? styles['map-full-screen'] : ''}`}>
            {isShowMap && <MapSection data={data?.map_list as ProductListRecord[]} loading={loading} isTehran={isTehran} mapFullscreen={mapFullscreen} setMapFullscreen={setMapFullscreen} />}
          </Box>
        </Box>}
    </>;
};
// }

export default memo(Products);